<template>
  <span>
    <ConnectedAccountOnboardingModal
      title="amazon vendor"
      :logo="amzvendor"
      :class="$style.container"
      :success="success"
      :disconnected="disconnected"
      :error="errors.amzvendor"
      logo-alt="Amazon logo"
      @click="openModal"
      @keyup.enter="openModal"
    />

    <ModalAmazonVendor
      ref="amazonVendorModal"
      :corp-country="corpCountry"
      @error="$emit('error', SALES_PLATFORMS.AMAZONVENDOR)"
      @success="$emit('success', SALES_PLATFORMS.AMAZONVENDOR)"
      @oauthError="(payload) => $emit('oauthError', payload)"
      @modalAction="
        (platformName, action) => $emit('modalAction', platformName, action)
      "
      @submit="continueAmazonVendorOauth"
    />
  </span>
</template>

<script>
import { SALES_PLATFORMS } from '@/data/platforms';
import { isMobileMixin } from '@/utils/vue-mixins';
import { LocalStorage, LocalStorageKeys } from '@/utils/local-storage';

import ConnectedAccountOnboardingModal from '@/pages/connected-accounts/components/ConnectedAccountOnboardingModal.vue';
import ModalAmazonVendor from '@/pages/connected-accounts/components/modals/ModalAmazonspapiVendor.vue';

import amazonIcon from '@/assets/logos/amazon_vendor_central.png';

export default {
  components: {
    ConnectedAccountOnboardingModal,
    ModalAmazonVendor,
  },
  mixins: [isMobileMixin],
  props: {
    success: Boolean,
    disconnected: Boolean,
    errors: Object,
    corpCountry: String,
  },
  computed: {
    amzvendor: () => amazonIcon,
    SALES_PLATFORMS: () => SALES_PLATFORMS,
  },
  methods: {
    openModal() {
      this.clearOauthParams();
      this.$emit('tileClick', SALES_PLATFORMS.AMAZON);
      this.$refs.amazonVendorModal.open();
    },
    continueAmazonVendorOauth(authorizeUri) {
      const options = { authorizeUri };

      if (this.isMobile()) {
        options.noPopup = true;
        options.redirectRoute = authorizeUri.split('&').find((arg) => {
          return !!arg.includes('redirect_uri');
        });
        LocalStorage.setItem(
          LocalStorageKeys.OAUTH_PROVIDER,
          SALES_PLATFORMS.AMAZONVENDOR,
        );
        LocalStorage.setItem(
          LocalStorageKeys.OAUTH_REDIRECT_ROUTE,
          options.redirectRoute,
        );
      }

      this.$emit('submit', options);
    },
    clearOauthParams() {
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_PROVIDER);
      LocalStorage.removeItem(LocalStorageKeys.OAUTH_REDIRECT_ROUTE);
    },
  },
};
</script>

<style lang="less" module>
.container {
  [class^='logo'] {
    max-height: unset;
  }
}
</style>
;
